import { Component, OnInit, Output, EventEmitter, Input, TemplateRef, OnDestroy } from '@angular/core';
import { NavigationService } from '../../../../providers/navigation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ITableColumnHeader } from '../../../../models/table-column-header';
import { Subscription } from 'rxjs';
import { ApiService } from '../../../../providers/api.service';
import { SM_CONSTANTS } from '../../../../shared/constants/sm-constants';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { MatDialog } from '@angular/material/dialog';
import { BookingDetailsComponent } from 'src/app/shared/components/booking-details/booking-details.component';
import { InvoiceComponent } from 'src/app/shared/components/invoice/invoice.component';
import { MessagingService } from 'src/app/providers/messaging.service';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { CustomConfirmDialogComponent } from 'src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { AddFutureBookingsComponent } from 'src/app/shared/components/add-future-bookings/add-future-bookings.component';
@Component({
  selector: 'sm-bookings-report',
  templateUrl: './bookings-report.component.html',
  styleUrls: ['./bookings-report.component.scss']
})
export class BookingsReportComponent implements OnInit, OnDestroy {
  isEntityIndividual: any = sessionStorage.getItem('isEntityIndividual')
  selectedFrequency: any = 1
  // frequencyOfView: any
  selectedView: any = 'Data'
  @Output() onButtonClick: EventEmitter<boolean> = new EventEmitter<boolean>();
 entityHashId: string = ''
  pageTitle: string = 'Booking History' ;
  @Input() pageSubTitle: string = '';
  @Input() showBackButton: boolean = false;
  @Input('buttonText') showButton: string = '';
  @Input()
  headerCustomTemplate!: TemplateRef<any>;
 
  fromDate:any = new Date();
  toDate:any = new Date();
  today: string = this.formatDate1(new Date())
  bookingsReportData: any[] = [];
  public loader: boolean = false;
  public visible: boolean = false;
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: this.translateService.instant('booking_report.column_headers.date'),
      columnProperty: "date"
    },
    {
      columnName: this.translateService.instant('booking_report.column_headers.total'),
      columnProperty: "total_bookings"
    },
    {
      columnName: this.translateService.instant('booking_report.column_headers.cancelled'),
      columnProperty: "cancelled_bookings"
    },
    {
      columnName: this.translateService.instant('booking_report.column_headers.shop'),
      columnProperty: "shop_bookings"
    },
    {
      columnName: this.translateService.instant('booking_report.column_headers.home'),
      columnProperty: "home_bookings"
    },
    {
      columnName: 'Virtual bookings',
      columnProperty: "virtual_bookings"
    },
    
  ];
  
  private _apiSubscription: Subscription;
  constructor(private _navService: NavigationService, private router: Router, private route: ActivatedRoute, private _apiService: ApiService, private loaderservice: LoaderServiceService, public _modelRef: MatDialog, private messagingService: MessagingService, 
    private angularFireMessaging: AngularFireMessaging,private translateService: TranslateService) {
    this._navService.hideSidebarAndNav = false;

    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_BOOKING_REPORT){
        this.bookingsReportData = []
        if(true){
          this.bookingsReportData = resData.result ? resData.result : [] 
          this.bookingsReportData.forEach(item => {
            if(item.month){
              item.month = this.convertDateString(item.month)
            }
          });
          //assign to graph
          if(this.selectedFrequency == 1){
            this.graphData = {
              datasets: [{
                  label: 'Shop Bookings',
                  data: this.bookingsReportData.map(item => {
                    return item.shop_bookings
                }),
                  // backgroundColor: "rgb(115 185 243 / 65%)",
                  borderColor: "#ff0000",
                  fill: false,
                  lineTension: 0
              },
              {
                label: 'Home Bookings',
                data: this.bookingsReportData.map(item => {
                  return item.home_bookings
              }),
                // backgroundColor: "#47a0e8",
                borderColor: "#007ee7",
                fill: false,
                lineTension: 0
        
              },
              {
                label: 'Virtual Bookings',
                data: this.bookingsReportData.map(item => {
                  return item.virtual_bookings
              }),
                // backgroundColor: "#47a0e8",
                borderColor: "#33cc33",
                fill: false,
                lineTension: 0
        
              },
              {
                label: 'Cancelled Bookings',
                data: this.bookingsReportData.map(item => {
                  return item.cancelled_bookings
              }),
                // backgroundColor: "#47a0e8",
                borderColor: "#ffc107",
                fill: false,
                lineTension: 0
        
              },
            ],
        
              labels: this.bookingsReportData.map(item => {
                return new Date(item.date).toLocaleDateString()
            })
        
          }
          }
          else if(this.selectedFrequency == 2){
            this.graphData = {
              datasets: [{
                label: 'Shop Bookings',
                data: this.bookingsReportData.map(item => {
                  return item.shop_bookings
              }),
                // backgroundColor: "rgb(115 185 243 / 65%)",
                borderColor: "#ff0000",
                fill: false,
                lineTension: 0
            },
            {
              label: 'Home Bookings',
              data: this.bookingsReportData.map(item => {
                return item.home_bookings
            }),
              // backgroundColor: "#47a0e8",
              borderColor: "#007ee7",
              fill: false,
              lineTension: 0
      
            },
            {
              label: 'Virtual Bookings',
              data: this.bookingsReportData.map(item => {
                return item.virtual_bookings
            }),
              // backgroundColor: "#47a0e8",
              borderColor: "#33cc33",
              fill: false,
              lineTension: 0
      
            },
            {
              label: 'Cancelled Bookings',
              data: this.bookingsReportData.map(item => {
                return item.cancelled_bookings
            }),
              // backgroundColor: "#47a0e8",
              borderColor: "#ffc107",
              fill: false,
              lineTension: 0
      
            },
          ],
        
              labels: this.bookingsReportData.map(item => {
                return item.month
            })
        
          }
          }
        }
        this.visible = true
        this.loaderservice.showLoader = false
      }
    })
    this.translateService.onLangChange.subscribe(() => {
      // Update your column headers when the language changes
      this.updateColumnHeaders();
    });
   }

   private updateColumnHeaders() {
    this.tableDisplayColumns.forEach((column,index) => {
      let data = [
        "date",
        "total",
        "cancelled",
        "shop",
        "home",
      ]
      // Update each column header with the translated value
      column.columnName = this.translateService.instant(`booking_report.column_headers.${data[index]}`);
    });
  }
  ngOnInit(): void {
   
    this.route.queryParams.subscribe(data => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash

      
    })
    this.fromDate.setDate(this.fromDate.getDate() - 30);
    this.fromDate = this.formatDate1(this.fromDate).slice(0,10);
    this.toDate = this.formatDate1(this.toDate).slice(0,10);
    this.loaderservice.showLoader = true
    this.visible = false
    this._apiService.getBookingReport(this.entityHashId,this.selectedFrequency.toString(), this.formatDate1(this.fromDate), this.formatDate1(this.toDate),this.isEntityIndividual == '1' ? '2' : '1')


  }
  search(){
       // Ensure date range is valid based on the selected frequency
       const fromDate = new Date(this.fromDate);
       const toDate = new Date(this.toDate);
   
       if (this.selectedFrequency === 1) { // Daily
         const maxRange = 90;
         const range = (toDate.getTime() - fromDate.getTime()) / (1000 * 3600 * 24);
         if (range > maxRange) {
           const dialogRef = this._modelRef.open(CustomConfirmDialogComponent,{
             data : {
               title : 'Alert',
               message : 'The selected time frame between from date and to date should be under 90 days.',
               okbtn : 'Ok',
               cancelbtn : 'Cancel',
               type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
             },
             disableClose : true
           });
           return;
         }
       } else if (this.selectedFrequency === 2) { // Monthly
         const maxRange = 36;
         const range = (toDate.getMonth() - fromDate.getMonth() + (12 * (toDate.getFullYear() - fromDate.getFullYear())));
         if (range > maxRange) {
           const dialogRef = this._modelRef.open(CustomConfirmDialogComponent,{
             data : {
               title : 'Alert',
               message : 'The selected time frame between from date and to date should be under 3 years.',
               okbtn : 'Ok',
               cancelbtn : 'Cancel',
               type : SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE
             },
             disableClose : true
           });
           return;
         }
       }
   
       //end
    if(this.selectedFrequency == 2){
      this.tableDisplayColumns = [
        {
          columnName: 'month',
          columnProperty: "month"
        },
        {
          columnName: 'total bookings',
          columnProperty: "total_bookings"
        },
        {
          columnName: 'cancelled bookings',
          columnProperty: "cancelled_bookings"
        },
        {
          columnName: 'shop bookings',
          columnProperty: "shop_bookings"
        },
        {
          columnName: 'home bookings',
          columnProperty: "home_bookings"
        },
        {
          columnName: 'Virtual bookings',
          columnProperty: "virtual_bookings"
        },
      ]
      this.loaderservice.showLoader = true
      this.visible = false
      this._apiService.getBookingReport(this.entityHashId,this.selectedFrequency.toString(), this.formatDate1(this.fromDate), this.formatDate1(this.toDate),this.isEntityIndividual == '1' ? '2' : '1')
    }
    else{
      this.tableDisplayColumns = [
        {
          columnName: 'date',
          columnProperty: "date"
        },
        {
          columnName: 'total bookings',
          columnProperty: "total_bookings"
        },
        {
          columnName: 'cancelled bookings',
          columnProperty: "cancelled_bookings"
        },
        {
          columnName: 'shop bookings',
          columnProperty: "shop_bookings"
        },
        {
          columnName: 'home bookings',
          columnProperty: "home_bookings"
        },
        {
          columnName: 'Virtual bookings',
          columnProperty: "virtual_bookings"
        },
      ]
      this.loaderservice.showLoader = true
      this.visible = false
      this._apiService.getBookingReport(this.entityHashId,this.selectedFrequency.toString(), this.formatDate1(this.fromDate), this.formatDate1(this.toDate),this.isEntityIndividual == '1' ? '2' : '1')
    }
  }

  changeFrequency(){
    if(this.selectedFrequency == 2){
      this.fromDate = new Date()
      this.toDate = new Date()
      this.fromDate.setDate(this.fromDate.getDate() - 365);
      this.fromDate = this.formatDate1(this.fromDate).slice(0,10);
      this.toDate = this.formatDate1(this.toDate).slice(0,10);
      this.tableDisplayColumns = [
        {
          columnName: 'month',
          columnProperty: "month"
        },
        {
          columnName: 'total bookings',
          columnProperty: "total_bookings"
        },
        {
          columnName: 'cancelled bookings',
          columnProperty: "cancelled_bookings"
        },
        {
          columnName: 'shop bookings',
          columnProperty: "shop_bookings"
        },
        {
          columnName: 'home bookings',
          columnProperty: "home_bookings"
        },
        {
          columnName: 'Virtual bookings',
          columnProperty: "virtual_bookings"
        },
      ]
      this.loaderservice.showLoader = true
      this.visible = false
      this._apiService.getBookingReport(this.entityHashId,this.selectedFrequency.toString(), this.formatDate1(this.fromDate), this.formatDate1(this.toDate),this.isEntityIndividual == '1' ? '2' : '1')
    }
    else{
      this.fromDate = new Date()
      this.toDate = new Date()
      this.fromDate.setDate(this.fromDate.getDate() - 30);
      this.fromDate = this.formatDate1(this.fromDate).slice(0,10);
      this.toDate = this.formatDate1(this.toDate).slice(0,10);
      this.tableDisplayColumns = [
        {
          columnName: 'date',
          columnProperty: "date"
        },
        {
          columnName: 'total bookings',
          columnProperty: "total_bookings"
        },
        {
          columnName: 'cancelled bookings',
          columnProperty: "cancelled_bookings"
        },
        {
          columnName: 'shop bookings',
          columnProperty: "shop_bookings"
        },
        {
          columnName: 'home bookings',
          columnProperty: "home_bookings"
        },
        {
          columnName: 'Virtual bookings',
          columnProperty: "virtual_bookings"
        },
      ]
      this.loaderservice.showLoader = true
      this.visible = false
      this._apiService.getBookingReport(this.entityHashId,this.selectedFrequency.toString(), this.formatDate1(this.fromDate), this.formatDate1(this.toDate),this.isEntityIndividual == '1' ? '2' : '1')
    }
  }
 
  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }

  navigate(){
    this.router.navigate(['../'], {relativeTo: this.route ,  queryParamsHandling: 'preserve'})
  }
 
  toShowGraph: boolean = false
  graphData: any
  changeView(){
    if(this.selectedView == 'Data'){
      this.toShowGraph = false
    }else if(this.selectedView == 'Graph'){
      if(this.selectedFrequency == 1){
        this.graphData = {
          datasets: [{
              label: 'Shop Bookings',
              data: this.bookingsReportData.map(item => {
                return item.shop_bookings
            }),
              // backgroundColor: "rgb(115 185 243 / 65%)",
              borderColor: "#ff0000",
              fill: false,
              lineTension: 0
          },
          {
            label: 'Home Bookings',
            data: this.bookingsReportData.map(item => {
              return item.home_bookings
          }),
            // backgroundColor: "#47a0e8",
            borderColor: "#007ee7",
            fill: false,
            lineTension: 0
    
          },
          {
            label: 'Virtual Bookings',
            data: this.bookingsReportData.map(item => {
              return item.virtual_bookings
          }),
            // backgroundColor: "#47a0e8",
            borderColor: "#33cc33",
            fill: false,
            lineTension: 0
    
          },
          {
            label: 'Cancelled Bookings',
            data: this.bookingsReportData.map(item => {
              return item.cancelled_bookings
          }),
            // backgroundColor: "#47a0e8",
            borderColor: "#ffc107",
            fill: false,
            lineTension: 0
    
          },
        ],
    
          labels: this.bookingsReportData.map(item => {
            return new Date(item.date).toLocaleDateString()
        })
    
      }
      }
      else if(this.selectedFrequency == 2){
        this.graphData = {
          datasets: [{
            label: 'Shop Bookings',
            data: this.bookingsReportData.map(item => {
              return item.shop_bookings
          }),
            // backgroundColor: "rgb(115 185 243 / 65%)",
            borderColor: "#ff0000",
            fill: false,
            lineTension: 0
        },
        {
          label: 'Home Bookings',
          data: this.bookingsReportData.map(item => {
            return item.home_bookings
        }),
          // backgroundColor: "#47a0e8",
          borderColor: "#007ee7",
          fill: false,
          lineTension: 0
  
        },
        {
          label: 'Virtual Bookings',
          data: this.bookingsReportData.map(item => {
            return item.virtual_bookings
        }),
          // backgroundColor: "#47a0e8",
          borderColor: "#33cc33",
          fill: false,
          lineTension: 0
  
        },
        {
          label: 'Cancelled Bookings',
          data: this.bookingsReportData.map(item => {
            return item.cancelled_bookings
        }),
          // backgroundColor: "#47a0e8",
          borderColor: "#ffc107",
          fill: false,
          lineTension: 0
  
        },
      ],
    
          labels: this.bookingsReportData.map(item => {
            return item.month
        })
    
      }
      }
    this.toShowGraph = true
    }
    
  }
  
  convertDateString(dateString:any) {
    // Split the input string to extract the year and month
    const [year, month] = dateString.split('-');

    // Array of month names
    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    // Convert month from string to number and adjust for zero-based index
    const monthIndex = parseInt(month, 10) - 1;

    // Retrieve the month name
    const monthName = monthNames[monthIndex];

    // Return the formatted string
    return `${monthName} ${year}`;
}
formatDate1(dateStr:Date) {

  let curdate = new Date(dateStr).toLocaleString('en-CA', {
    timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' 
}).slice(0, 10);
    console.log(curdate);
    
    return curdate
}

}


